const HttpClient = require('./httpClient')

class AuthService {
  constructor(client) {
    this.client = client
  }

  async getAuth(apiToken, merchantId) {
    try {
      return this.client.authenticate(apiToken, merchantId)
    } catch (error) {
      throw error
    }
  }
}

module.exports = AuthService
